var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.72747V3.59414C2 3.26277 2.26863 2.99414 2.6 2.99414H6.06667C6.39804 2.99414 6.66667 3.26277 6.66667 3.59414V5.72747C6.66667 6.05885 6.39804 6.32747 6.06667 6.32747H2.6C2.26863 6.32747 2 6.05885 2 5.72747Z",
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 14.3935V12.2602C9.33301 11.9288 9.60164 11.6602 9.93301 11.6602H13.3997C13.731 11.6602 13.9997 11.9288 13.9997 12.2602V14.3935C13.9997 14.7249 13.731 14.9935 13.3997 14.9935H9.93301C9.60164 14.9935 9.33301 14.7249 9.33301 14.3935Z",
    stroke: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 9.06081V3.59414C9.33301 3.26277 9.60164 2.99414 9.93301 2.99414H13.3997C13.731 2.99414 13.9997 3.26277 13.9997 3.59414V9.06081C13.9997 9.39218 13.731 9.66081 13.3997 9.66081H9.93301C9.60164 9.66081 9.33301 9.39218 9.33301 9.06081Z",
    stroke: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.3948V8.92813C2 8.59675 2.26863 8.32812 2.6 8.32812H6.06667C6.39804 8.32812 6.66667 8.59675 6.66667 8.92812V14.3948C6.66667 14.7262 6.39804 14.9948 6.06667 14.9948H2.6C2.26863 14.9948 2 14.7262 2 14.3948Z",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportColumns);
export default __webpack_public_path__ + "static/media/reportColumns.161561c714cb8b015a3a543fe98a4ba8.svg";
export { ForwardRef as ReactComponent };